function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  opacity: ".4",
  d: "M12 22c5.523 0 10-4.477 10-10S17.523 2 12 2 2 6.477 2 12s4.477 10 10 10z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M16.69 15.7l-4-9c-.24-.54-1.13-.54-1.37 0L9.3 11.25H8c-.41 0-.75.34-.75.75s.34.75.75.75h.62L7.31 15.7c-.17.38 0 .82.38.99.38.17.82 0 .99-.38l1.58-3.55H12c.41 0 .75-.34.75-.75s-.34-.75-.75-.75h-1.07L12 8.86l3.31 7.46c.12.28.4.45.69.45.1 0 .21-.02.3-.06.38-.19.55-.64.39-1.01z"
})));